import BreakpointRangeName from './BreakpointRangeName';
import { MEDIUM_CONTAINER_WIDTH, MIDDLE_CONTAINER_WIDTH, SMALL_CONTAINER_WIDTH } from './constants';
import { BreakpointRange as MewsBreakpointRange } from './types';

const BreakpointRange: MewsBreakpointRange = {
    [BreakpointRangeName.Phone]: {
        low: 0,
        high: SMALL_CONTAINER_WIDTH,
    },
    [BreakpointRangeName.TabletPortrait]: {
        low: SMALL_CONTAINER_WIDTH + 1,
        high: MIDDLE_CONTAINER_WIDTH,
    },
    [BreakpointRangeName.TabletLandscape]: {
        low: MIDDLE_CONTAINER_WIDTH + 1,
        high: MEDIUM_CONTAINER_WIDTH,
    },
    [BreakpointRangeName.Desktop]: {
        low: MEDIUM_CONTAINER_WIDTH + 1,
        high: 2 ** 15 - 1,
    },
};

export default BreakpointRange;
